/* eslint-disable react/jsx-no-bind */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-bootstrap';
import cn from 'classnames';
import { Map } from 'immutable';
import style from './style.scss';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  className: PropTypes.string,
  showBackground: PropTypes.bool,
  isSlider: PropTypes.bool,
};

function Logo({ settings, event, className = '', imgClassName = '', showBackground, isSlider }) {
  const logo = event.getIn(['logo', 'url']);
  const disableImageZoom = settings.get('disableImageZoom');
  const secondaryImages = event.getIn(['logo', 'secondaryImages']);
  const title = event.get('title');

  if (!logo) return <span />;
  if (secondaryImages && secondaryImages.size > 0) {
    return <ImageCarousel event={event} urls={[logo].concat(secondaryImages.toJS())} settings={settings} />;
  }
  return (
    <div className={cn('logo', isSlider ? style.sliderPhoto : style.photo, className)}>
      <ZoomWrapper scale={disableImageZoom ? 1.0 : 2.0}>
        <img src={logo} alt={title} className={cn(style.mainLogo, imgClassName)} />
      </ZoomWrapper>
      {showBackground && <img src={logo} alt={title} className={style.backgroundLogo} />}
    </div>
  );
}

Logo.propTypes = propTypes;

export default Logo;

const ImageCarousel = ({ urls, event, settings }) => {
  const [index, setIndex] = useState(0);
  const ref = useRef();

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const title = event.get('title');
  const slide = settings.get('logoCarouselSlider');
  const disableImageZoom = settings.get('disableImageZoom');

  return (
    <div ref={ref}>
      <ZoomWrapper scale={disableImageZoom ? 1.0 : 1.8}>
        <Carousel activeIndex={index} onSelect={handleSelect} interval={slide ? 5000 : null} className={style.carouselContainer}>
          {urls.map((url) => (
            <Carousel.Item>
              <img className={`carousel-image d-block ${style.carouselImg}`} src={url} alt={title} style={{ height: 'auto' }} />
            </Carousel.Item>
          ))}
        </Carousel>
      </ZoomWrapper>
    </div>
  );
};

const ZoomWrapper = ({ children, scale }) => {
  const [isZoomed, setIsZoomed] = useState(false);

  const handleZoom = () => {
    setIsZoomed(!isZoomed);
  };

  const zoomStyle = {
    transform: isZoomed ? `scale(${scale})` : 'scale(1)',
    transition: 'transform 0.3s ease',
    zIndex: isZoomed ? 10000 : 'auto',
    position: 'relative',
    cursor: 'pointer',
  };

  return (
    <div style={{ cursor: 'pointer' }} onClick={handleZoom}>
      <div style={zoomStyle}>{children}</div>
    </div>
  );
};
